import { get } from 'lodash-es';

/**
 * 获取判断条件配置属性的值
 * @param condition 逻辑判断配置数据
 * @param result 当前已解析的数据
 * @param currentResult 当前同级节点的数据
 * @returns
 */
const fetchConditionTargetValue = (condition: Condition, result: any, currentResult: any) => {
  const { findType, prop } = condition;
  switch (findType) {
    case 'root':
      return get(result, prop);
    case 'current':
      return get(currentResult, prop);
    default:
      return get(result, prop) ?? get(currentResult, prop);
  }
};

/**
 * 执行判断逻辑操作
 * @param condition 逻辑判断配置数据
 * @param result 当前已解析的数据
 * @param currentResult 当前同级节点的数据
 * @returns {boolean} 判断结果
 */
const conditionOperate = (condition: Condition, result: any, currentResult: any): boolean => {
  const { operation = 'eq', value } = condition;
  const target = fetchConditionTargetValue(condition, result, currentResult);
  switch (operation) {
    case 'eq':
      return target === value;
    case 'neq':
      return target !== value;
    case 'lt':
      return target < value;
    case 'lte':
      return target <= value;
    case 'gt':
      return target > value;
    case 'gte':
      return target >= value;
    default:
      // 无法实别的判断类型，返回false
      return false;
  }
};

/**
 * 判断字段是否需要解析
 * @param condition 判断条件
 * @param result 当前已解析数据
 * @param currentResult 当前同级节点的数据
 * @returns
 */
export const transformEnabled = (
  condition: Condition | CompositeCondition,
  result: any,
  currentResult: any
): boolean => {
  if (condition) {
    // 是否为复合操作
    if ('conditions' in condition) {
      const { conditions, type } = condition;
      if (type === 'or') {
        return conditions.some(cond => transformEnabled(cond, result, currentResult));
      }
      return conditions.every(cond => transformEnabled(cond, result, currentResult));
    } else {
      // 判断
      return conditionOperate(condition, result, currentResult);
    }
  }

  // 无配置时，返回可解析
  return true;
};
